import { useContext } from 'react';
import TranslatorContext from './TranslatorContext';

export const useTranslator = () => {
  return useContext(TranslatorContext);
};
